import { defineStore } from "pinia";
import { ref } from "vue";

export const useEventPageStore = defineStore("eventPage", () => {
  const isLoading = ref(false);
  const enabledLocales = ref([]);

  const setLoading = (value) => {
    isLoading.value = value;
  };

  const setEventLocales = (locales) => {
    enabledLocales.value = Array.isArray(locales) ? locales : [];
  };

  const clearEventLocales = () => {
    enabledLocales.value = [];
  };

  return {
    isLoading,
    enabledLocales,
    setLoading,
    setEventLocales,
    clearEventLocales
  };
});
